import { OCCURRENCE_TYPES, USAGE_TYPE } from './BusinessOverview/Plans/Enums';

const API_URLS = Object.freeze({
  ActiveProductsStatus: '/productsAndServices/v1/activeProductsStatus',
  Product: '/tmf-api/productInventory/v4/product',
  ProductOffering: '/tmf-api/productCatalogManagement/v4/productOffering',
  ProductAndOfferingRecommendation: '/productsAndServices/v1/productAndOfferingRecommendation',
  CheckEligibleParty: '/productsAndServices/v1/checkEligibleParty',
});
const EXTRAS_OPTION_CONFIG = Object.freeze({
  [USAGE_TYPE.DATA]: {
    [OCCURRENCE_TYPES.RECURRING]: {
      title: 'soho_plans_add_usage_data_occurrence_second_option_title',
      description: 'soho_plans_add_usage_data_recurring_payment_statement',
    },
    [OCCURRENCE_TYPES.ONE_OFF]: {
      title: 'soho_plans_add_usage_data_occurrence_first_option_title',
      description: 'soho_plans_add_usage_data_one_off_payment_statement',
    },
  },
  [USAGE_TYPE.SMS]: {
    [OCCURRENCE_TYPES.RECURRING]: {
      title: 'soho_plans_add_usage_sms_occurrence_second_option_title',
      description: 'soho_plans_add_usage_sms_recurring_payment_statement',
    },
    [OCCURRENCE_TYPES.ONE_OFF]: {
      title: 'soho_plans_add_usage_sms_occurrence_first_option_title',
      description: 'soho_plans_add_usage_sms_one_off_payment_statement',
    },
  },
  [USAGE_TYPE.CALLS]: {
    [OCCURRENCE_TYPES.RECURRING]: {
      title: 'soho_plans_add_usage_calls_occurrence_second_option_title',
      description: 'soho_plans_add_usage_calls_recurring_payment_statement',
    },
    [OCCURRENCE_TYPES.ONE_OFF]: {
      title: 'soho_plans_add_usage_calls_occurrence_first_option_title',
      description: 'soho_plans_add_usage_calls_one_off_payment_statement',
    },
  },
});

export { API_URLS, EXTRAS_OPTION_CONFIG };
